// eslint-disable-next-line @typescript-eslint/naming-convention
export const FiscalCode_IT_MaxLength: number = 16;
export const IBAN_IT_MaxLength: number = 27;

/// Complex regex to validate name and surname
export const NameAndSurnameRegex: RegExp = /^\b([A-ZÀ-ÿ][-,a-z. ']+['']*)+$/;

/// Complex regex to validate an email
export const EmailRRegExp = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

/// Complex regex to validate an italian FiscalCode of a person
export const FiscalCodeCompleteRegex: RegExp =
    /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i;

/// Simplify regex to validate an italian FiscalCode of a person
export const FiscalCodeSimplifyRegex: RegExp = /^([A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1})$|^[0-9]{11}$/;

/// Regex to validate an italian postal code
export const PostalCode_IT_Regex: RegExp = /^\d{5}$/;

/// regex to validate an italian vatcode (trad. partita iva)
export const VatCodeRegex: RegExp = /^\d{11}$/;

/// regex to validate a phone number
export const PhoneNumberRegex: RegExp = /^(\+[0-9]{1,3})?\s?[0-9]{2,4}\s?[0-9]{3,13}$/;

/// regex to validate an italian IBAN
export const IBAN_IT_Regex: RegExp = /^IT\d{2}[A-Z]{1}\d{10}[A-Z0-9]{12}$/;

/// regex to validate a number
export const NumberRegex: RegExp = /^\d+$/;

// password regex
export const passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$';

// date ISO string regex
export const isoStringRegex = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
